import React from 'react';
import GenericComponent from 'components/utility/GenericComponent/GenericComponent';
import TableControls from 'components/base/TableControls/TableControls';
import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import {
  FakeButtonWrapper,
  FakeRedesignButton,
  FakeDropdown,
  FullScreenDropdownWrapper,
  FakeSearch,
} from 'components/base/SkeletonLoader/FakeInteractive';
import Table from 'components/data-visualization/Table/Table';
import Row from 'components/data-visualization/Table/Row';
import getTableHeaders from './utils/getTableHeaders';
import { Head, Label } from 'components/data-visualization/Table/SortingHead';

import styled from 'styled-components/macro';
import useMedia from 'hooks/useMedia';
import {
  Header,
  TableRow,
  TableCell,
} from 'components/data-containers/PositionsTable/shared/PositionsTable.style';
import TableLoader from 'components/utility/ContentLoader/TableLoader/TableLoader';
import TableBody from 'components/data-visualization/Table/Body';
import { ContentWrapper, SearchFieldBlock } from './shared/shared.style';

const TableWrapper = styled(Table)`
  margin: ${({ theme }): any => `${theme.spacing.xlarge} 0`};
`;

export default function ShortFormVideoTerritorySkeletonLoader(): JSX.Element {
  const isLargeScreen = useMedia('(min-width: 50em)');

  const toggleOptions = [
    { value: 'creations', label: 'Creations', active: true },
    { value: 'views', label: 'Views', active: false },
  ];

  const headers = getTableHeaders();

  return (
    <ContentWrapper>
      <GenericComponent
        title="Short Form Video Territory Creations"
        loading={true}
        success={false}
        showToolbarDropdown={false}
      >
        <AnimatedLoadingWrapper loading={true}>
          <TableControls>
            <SearchFieldBlock>
              <FakeSearch>Search</FakeSearch>
            </SearchFieldBlock>
            {isLargeScreen && toggleOptions ? (
              <FakeButtonWrapper>
                {toggleOptions.map((option) => (
                  <FakeRedesignButton key={option.value} active={option.active}>
                    {option.label}
                  </FakeRedesignButton>
                ))}
              </FakeButtonWrapper>
            ) : (
              <>
                <FullScreenDropdownWrapper>
                  <FakeDropdown>Last Full Week</FakeDropdown>
                </FullScreenDropdownWrapper>

                <FakeButtonWrapper>
                  {toggleOptions &&
                    toggleOptions.map((option: any) => (
                      <FakeRedesignButton
                        key={option.value}
                        active={option.active}
                      >
                        {option.label}
                      </FakeRedesignButton>
                    ))}
                </FakeButtonWrapper>
              </>
            )}
          </TableControls>

          <TableWrapper>
            {isLargeScreen && (
              <Head>
                <Row>
                  {headers.map(
                    (header: any) =>
                      header.key !== 'expand' && (
                        <Header key={header.value}>
                          <Label>{header.label}</Label>
                        </Header>
                      )
                  )}
                </Row>
              </Head>
            )}
            <TableBody>
              <TableLoader
                columnCount={headers.length}
                rowComponent={TableRow}
                cellComponent={TableCell}
              />
            </TableBody>
          </TableWrapper>
        </AnimatedLoadingWrapper>
      </GenericComponent>
    </ContentWrapper>
  );
}
